import { WorkspaceDetailsBanner } from '../WorkspaceDetailsBanner'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { CustomMenuSection } from './CustomMenuSection'
import { DirectLinkedUsersSection } from './DirectLinkedUsersSection'
import { ProjectTeamsSection } from './ProjectTeamsSection'
import { SupportTeamsSection } from './SupportTeamsSection'
import { SectionLayout } from '@/pages/shared-components/SectionLayout'

export const WorkspaceDetailsPage = () => {
  return (
    <>
      <WorkspacesBreadcrumbs title="Details" />
      <SectionLayout>
        <WorkspaceDetailsBanner />
        <ProjectTeamsSection />
        <SupportTeamsSection />
        <CustomMenuSection />
        <DirectLinkedUsersSection />
      </SectionLayout>
    </>
  )
}
